import {
    TICKET_EXCLUDED_ROLES,
    TICKET_NON_AUTO_ASSIGN_ROLES,
    TICKET_ROLE_OPTIONS_KEY,
    TICKET_TOPIC_OPTIONS_KEYS
} from "constants/ticket";
import {sortByName} from "../common/ticketUtils";

export const getRoleOptions = options =>
    sortByName(
        (options?.[TICKET_ROLE_OPTIONS_KEY] || []).filter(
            role => !TICKET_EXCLUDED_ROLES.includes(role.key)
        )
    );

// Otomatik atama departmanları; yalnızca elle atanabilen roller (ör. Acente Temsilcisi) listelenmez
export const getAutoAssignRoleOptions = options =>
    getRoleOptions(options).filter(role => !TICKET_NON_AUTO_ASSIGN_ROLES.includes(role.key));

export const getTopicOptions = (options, category) =>
    options?.[TICKET_TOPIC_OPTIONS_KEYS[category]] || [];
